import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    // NotificationPreference_UNSPECIFIED (0) is the null value, and as such is
    // invalid.
    //
    // Note:
    // - We ensure this edge case doesn't propagate by normalizing the
    //   serialized response via the person serializer.

    // NotificationPreference_DEFAULT (1) sends push notifications by default
    // if the person has devices. If they have no devices, Hero will fall back
    // to sending email notifications.
    { value: 1, label: 'Default' },

    // NotificationPreference_EMAIL (2) specifies that the person has chosen to
    // only receive notifications via e-mail. It should be noted, that our email
    // notifications have a length limitation, therefore the person may still
    // need to sign into Hero in order to view the full notification.
    { value: 2, label: 'Email' },

    // NotificationPreference_NONE (3) specifies the person has chosen to
    // receive no notifications from Hero.
    { value: 3, label: 'None' },
  ],
});
